<template>
  <div class="select-title">
        <el-input class="select-search pc" v-if="!noSearch" v-model="keywords" @keyup.native.enter="changeSearch" placeholder="请输入关键词">
          <img slot="suffix" src="https://static.worldaic.com.cn/2024/web/static/images/search2.png" @click="changeSearch" alt="">
        </el-input>
        <el-input class="select-search wap" :class="{ 'has-select': hasSelect }" v-model="keywords" @change="changeSearch" :placeholder="hasSelect ? ' ' : '请输入关键词'">
          <img slot="prefix" src="https://static.worldaic.com.cn/2024/web/static/images/search2.png" alt="" @click="changeSearch">
        </el-input>
        <div class="select-btn wap" @click="showMask">
          <img src="https://static.worldaic.com.cn/2024/web/static/images/select.png" alt="">
        </div>
        <div class="select-data-wrapper" v-if="hasSelect" id="select-data-wrapper">
          <div class="select-data">
            <template v-for="(item, index) in select">
              <span :key="index" v-if="item != -1">
                {{ item['name' + En] }}
                <i @click="closeItem(index)">
                  <img src="https://static.worldaic.com.cn/2024/web/static/images/select-close-active.png" alt="">
                </i>
              </span>
            </template>
          </div>
        </div>

        <div class="select-mask wap" v-show="show"></div>

        <transition name="fade">
          <div class="select-content" v-show="show">
            <div class="select-content-title wap">
              筛选
              <span @click="close"><img src="https://static.worldaic.com.cn/2024/web/static/images/select-close.png" alt=""></span>
            </div>
            <div class="item-wrapper">
              <div class="item" v-for="(item, index) in data" :key="index">
                <span class="label">{{ item['name' + En] }}：</span>
                <ul>
                  <li v-for="(ite, ind) in item.types" :key="ind" :class="{ active: actives[index] === ind, 'pub-btn-bg': actives[index] === ind }" @click="change(index, ind, item.name, ite.name)">{{ ite['name' + En] }}</li>
                </ul>
              </div>
            </div>
            <div class="select-content-bottom wap">
              <div @click="actives = initArr">全部清除</div>
              <div @click="sure">确认</div>
            </div>
          </div>
        </transition>
  </div>
</template>

<script>
import BScroll from "better-scroll";

export default {
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    noSearch: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      initArr: [],
      actives: [],
      select: [],
      show: false,
      keywords: '',
      params: ''
    }
  },
  activated() {
    if (this.$route.query.search) {
      this.keywords = this.$route.query.search
      this.changeSearch()
    }
  },
  watch: {
    data: {
      handler(v) {
        if (v && v.length) {
          v = v.filter(x => x.types && x.types.length)
          this.initArr = new Array(v.length).fill(-1)
          this.actives = new Array(v.length).fill(-1)
          this.select = new Array(v.length).fill(-1)
        }
      },
      immediate: true
    }
  },
  computed: {
    hasSelect() {
      let flag = false
      this.select.forEach(x => {
        if (x != -1) {
          flag = true
        }
      })
      return flag
    }
  },
  methods: {
    setScroll() {
      if (!this.hasSelect) return
      this.$nextTick(() => {
          this.scrollLeft = new BScroll(document.getElementById(`select-data-wrapper`), {
            probeType: 3,
            click: true,
            scrollX: true
          })
      })
    },
    changeSearch() {
      this.$emit('params', {...this.params, keywords: this.keywords, hideTime: '1'})
    },
    change(index, ind, itemName, iteName) {
      this.$set(this.actives, index, this.actives[index] === ind ? -1 : ind)
      this.setParams()
      this.$emit('clickSearch', { typeName: itemName, name: iteName })
    },
    setParams() {
      const params = {}
      this.actives.forEach((x, i) => {
        if (x != -1) {
          params[this.data[i].paramField] = this.data[i].types[x].ids
        }
      })
      this.params = params
      this.$emit('params', {...params, keywords: this.keywords})
    },
    showMask() {
      this.show = true
    },
    close() {
      this.show = false
    },
    sure() {
      this.select = this.actives.map((x, i) => x != -1 ? this.data[i].types[x] : -1)
      this.setParams()
      this.setScroll()
      this.close()
    },
    closeItem(index) {
      this.$set(this.select, index, -1)
      this.$set(this.actives, index, -1)
      this.setParams()
      this.setScroll()
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .select-title {
    .select-search {
      margin-top: .47rem;

      /deep/ .el-input__inner {
        background-color: transparent;
        height: .52rem;
        background: rgba(255, 255, 255, 0.4);
        border-radius: .06rem;
        border: 1px solid rgba(47, 154, 244, 0.2);
        font-size: .2rem;
        // border-image: linear-gradient(126deg, rgba(47, 154, 244, 0.6), rgba(195, 4, 226, 0.6)) 1 1;
      }

      /deep/ .el-input__suffix {
        display: flex;
        align-items: center;
        margin-right: .2rem;
        cursor: pointer;

        img {
          width: .26rem;
          height: .26rem;
        }
      }
    }

    .select-content {
      margin-top: .38rem;
      padding-bottom: .24rem;
      position: relative;
      display: block !important;

      .item {
        display: flex;
        font-size: .22rem;
        font-family: sybold;
        color: #9E9F9F;
        line-height: .32rem;

        .label {
          width: 1.1rem;
          color: #403E3E;
          font-size: .18rem;
          font-family: sybold;
          margin-bottom: .12rem;
          overflow: hidden;
        }

        ul {
          flex: 1;
          overflow: hidden;
          display: flex;
          flex-wrap: wrap;

          li {
            margin-right: .16rem;
            cursor: pointer;
            min-width: 1.48rem;
            height: .32rem;
            border-radius: .16rem;
            line-height: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            background: linear-gradient(126deg, RGBA(60, 140, 242, 0.1) 0%, RGBA(118, 82, 235, 0.1) 100%);
            color: #404040;
            font-size: .17rem;
            padding: 0 .1rem;
            margin-bottom: .12rem;

            &:first-child {
              width: .88rem;
            }

            &.active {
              color: #fff;
              background: linear-gradient(126deg, RGBA(60, 140, 242, 1) 0%, RGBA(118, 82, 235, 1) 100%);
            }
          }
        }
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .select-title {
    display: flex;
    margin-top: .47rem;

    .select-search {
      flex: 1;
      margin-right: .16rem;

      /deep/ .el-input__inner {
        background-color: transparent;
        height: .84rem;
        background: rgba(255, 255, 255, 0.4);
        border-radius: .12rem;
        border: 1px solid rgba(47, 154, 244, 0.2);
        font-size: .28rem;
        padding-left: .68rem;
        // border-image: linear-gradient(126deg, rgba(47, 154, 244, 0.6), rgba(195, 4, 226, 0.6)) 1 1;
      }

      /deep/ .el-input__prefix {
        display: flex;
        align-items: center;
        left: .23rem;
        height: .84rem;

        img {
          width: .31rem;
          height: .31rem;
        }
      }

      &.has-select {
        flex: 0 0 .8rem;

        /deep/ .el-input__inner {
          padding-left: 0;
        }

        /deep/ .el-input__prefix {
          left: .24rem;
        }
      }
    }

    .select-btn {
      flex: 0 0 .8rem;
      height: .84rem;
      background: rgba(255, 255, 255, 0.8);
      border-radius: .12rem;
      border: 1px solid rgba(47, 154, 244, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: .44rem;
        height: .44rem;
      }
    }

    .select-data-wrapper {
      flex: 1;
      margin-left: .16rem;
      overflow: hidden;

      .select-data {
        display: inline-block;
        white-space: nowrap;
        font-size: 0;

        span {
          padding: 0 .48rem 0 .2rem;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          height: .64rem;
          border: 1px solid rgba(47, 154, 244, 0.2);
          position: relative;
          border-radius: .32rem;
          font-size: .26rem;
          color: #2F9AF4;
          line-height: 1;
          margin-right: .16rem;
          margin-top: .1rem;

          i {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            width: .48rem;
            height: .48rem;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: .19rem;
              height: .19rem;
            }
          }
        }
      }
    }
  }

  .select-mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 110;
    background: rgba(0, 0, 0, 0.5);
  }

  .select-content {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #F5F5F5;
    border-radius: .16rem .16rem 0 0;
    z-index: 111;

    .select-content-title {
      height: 1.08rem;
      position: relative;
      border-bottom: 1px solid #E0E0E0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: .32rem;
      line-height: 1;
      font-weight: bold;

      span {
        position: absolute;
        right: 0;
        top: 0;
        width: 1.08rem;
        height: 1.08rem;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: .28rem;
          height: .28rem;
        }
      }
    }

    .item-wrapper {
      max-height: calc(100vh - 4rem);
      overflow: auto;
    }

    .item {
      margin-top: .32rem;
      padding-left: .32rem;
      padding-bottom: .3rem;

      .label {
        font-size: .26rem;
        font-weight: bold;
        color: #403E3E;
        line-height: 1;
        display: block;
        margin-bottom: .28rem;
      }

      ul {
        display: flex;
        flex-wrap: wrap;

        li {
          margin-right: .24rem;
          cursor: pointer;
          min-width: 2.12rem;
          height: .64rem;
          border-radius: .32rem;
          line-height: 1;
          padding: 0 .3rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: .26rem;
          color: #404040;
          background: linear-gradient(126deg, RGBA(227, 235, 245, 1) 0%, RGBA(232, 229, 244, 1) 100%);
          overflow: hidden;
          margin-bottom: .16rem;

          &.active {
            color: #fff;
          }
        }
      }
    }

    .select-content-bottom {
      box-sizing: content-box;
      padding-bottom: constant(safe-area-inset-bottom);
      height: 1.28rem;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;

      div {
        width: 3.32rem;
        height: .72rem;
        border-radius: .36rem;
        margin: 0 .11rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .3rem;
        line-height: 1;

        &:first-child {
          border: .02rem solid #0361FF;
          color: #0361FF;
        }

        &:last-child {
          background: RGBA(3, 97, 255, 1);
          color: #fff;
        }
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: transform .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translateY(100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/select-title.vue